import { gql } from '@apollo/client';

const CHECKLIST_IMPLEMENTATIONS = gql`
  fragment ChecklistImplementations on Checklist {
    id
    type
    ... on BenchmarkChecklist {
      details {
        checklistId
        period
        productCurriculumId
      }
    }
    ... on UnitChecklist {
      unitId
      unit {
        id
        productCurriculumId
        unitNumber
        title
        description
      }
    }
    ... on WeeklyChecklist {
      weekNumber
      unitId
      unit {
        id
        productCurriculumId
        unitNumber
        title
        description
      }
    }
  }
`;

export { CHECKLIST_IMPLEMENTATIONS };
